import { render, staticRenderFns } from "./zipUpload.vue?vue&type=template&id=bc8c6906&scoped=true&"
import script from "./zipUpload.vue?vue&type=script&lang=js&"
export * from "./zipUpload.vue?vue&type=script&lang=js&"
import style0 from "./zipUpload.vue?vue&type=style&index=0&id=bc8c6906&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8c6906",
  null
  
)

export default component.exports